<template>
  <div>
      <info-beneficiario></info-beneficiario>
  </div>
</template>

<script>
export default {
  components: {
    "info-beneficiario": require("../components/InfoBeneficiario.vue").default
  }
};
</script>

